export default {"src":"/_next/static/media/map-pin-fill.6d619e30.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};